import { render, staticRenderFns } from "./salary-back-pay.vue?vue&type=template&id=635097f6"
import script from "./salary-back-pay.vue?vue&type=script&lang=js"
export * from "./salary-back-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports